module.exports = __webpack_public_path__ + "img/error-red.824e187a.svg";